import React, { useEffect, useState } from "react";

const Navdata = () => {
  //state data
  const [isMaster, setIsMaster] = useState(false);
  const [isBanner, setIsBanner] = useState(false);
  const [isEcommerce, setIsEcommerce] = useState(false);
  const [isOrder, setIsOrder] = useState(false);
  const [isSellers, setIsSellers] = useState(false);
  const [isInvoice, setIsInvoice] = useState(false);
  const [isShipping, setIsShipping] = useState(false);
  const [isLocalization, setIsLocalization] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isMultiLevel, setIsMultiLevel] = useState(false);
  const [isDesigner, setIsDesigner] = useState(false);
  const [isBlog, setIsBlog] = useState(false);
  const [isPages, setIsPages] = useState(false);
  // Multi Level
  const [isLevel1, setIsLevel1] = useState(false);
  const [isLevel2, setIsLevel2] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        // var id = item.getAttribute("subitems");
        // if (document.getElementById(id)){
        //     document.getElementById(id).classList.remove("show");
        // }
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "Ecommerce") {
      setIsEcommerce(false);
    }
    if (iscurrentState !== "isMaster") {
      setIsMaster(false);
    }
    if (iscurrentState !== "isBanner") {
      setIsBanner(false);
    }
    if (iscurrentState !== "Orders") {
      setIsOrder(false);
    }
    if (iscurrentState !== "Sellers") {
      setIsSellers(false);
    }
    if (iscurrentState !== "Invoice") {
      setIsInvoice(false);
    }
    if (iscurrentState !== "Shipping") {
      setIsShipping(false);
    }
    if (iscurrentState !== "Localization") {
      setIsLocalization(false);
    }
    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    //addedby sahin
    if (iscurrentState !== "Designers") {
      setIsDesigner(false);
    }
    if (iscurrentState !== "Blogs") {
      setIsBlog(false);
    }
    if (iscurrentState !== "Pages") {
      setIsPages(false);
    }
  }, [
    iscurrentState,
    isMaster,
    isEcommerce,
    isOrder,
    isInvoice,
    isShipping,
    isLocalization,
    isAuth,
    isMultiLevel,
    isDesigner, //addedby sahin
    isBlog, //addedby sahin
    isPages
  ]);

  const menuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "bi bi-speedometer2",
      link: "/dashboard",

      badgeColor: "danger",
    },
    {
      id: "products",
      label: "Products",
      icon: "bi bi-box-seam",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsEcommerce(!isEcommerce);
        setIscurrentState("Ecommerce");
        updateIconSidebar(e);
      },
      stateVariables: isEcommerce,
      subItems: [
        {
          id: "listview",
          label: "List View",
          link: "/products-list",
          parentId: "products",
        },
        // {
        //     id: "gridview",
        //     label: "Grid View",
        //     link: "/products-grid",
        //     parentId: "products",
        // },
        // {
        //     id: "overview",
        //     label: "Overview",
        //     link: "/product-overview",
        //     parentId: "products",
        // },
        {
          id: "createproduct",
          label: "Create Product",
          link: "/product-create",
          parentId: "products",
        },
        {
          id: "categories",
          label: "Categories",
          link: "/categories",
          parentId: "products",
        },
        // {
        //     id: "subcategories",
        //     label: "Sub Categories",
        //     link: "/sub-categories",
        //     parentId: "products",
        // },
      ],
    },
    //addedby sahin
    {
      id: "designers",
      label: "Designers",
      icon: "bi bi-palette",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsDesigner(!isDesigner);
        setIscurrentState("Designers");
        updateIconSidebar(e);
      },
      stateVariables: isDesigner,
      subItems: [
        {
          id: "designerList",
          label: "Designer List",
          link: "/designer-list",
          parentId: "designer",
        },
        {
          id: "createDesigner",
          label: "Create Designer",
          link: "/designer-create",
          parentId: "designer",
        },
      ],
    },
    {
      id: "blogs",
      label: "Blogs",
      icon: "bi bi-journal-text",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsBlog(!isBlog);
        setIscurrentState("Blogs");
        updateIconSidebar(e);
      },
      stateVariables: isBlog,
      subItems: [
        {
          id: "blogList",
          label: "Blog List",
          link: "/blog-list",
          parentId: "blog",
        },
        {
          id: "blogDesigner",
          label: "Create Blog",
          link: "/blog-create",
          parentId: "blog",
        },
      ],
    },
    {
  id: "pages",
  label: "Pages",
  icon: "bi bi-file-text",
  link: "/#",
  click: function (e) {
    e.preventDefault();
    setIsPages(!isPages);
    setIscurrentState("Pages");
    updateIconSidebar(e);
  },
  stateVariables: isPages,
  subItems: [
    {
      id: "pageList",
      label: "Page List",
      link: "/page-list",
      parentId: "pages",
    },
    {
      id: "createPage",
      label: "Create Page",
      link: "/page-create",
      parentId: "pages",
    },
  ],
},

    {
      id: "Mastersetting",
      label: "Master Setting",
      icon: "bi bi-box-seam",
      link: "/#",

      click: function (e) {
        e.preventDefault();
        setIsMaster(!isMaster);
        setIscurrentState("isMaster");
        updateIconSidebar(e);
      },
      stateVariables: isMaster,
      subItems: [
        {
          id: "color",
          label: "Color",
          link: "/color",
          parentId: "Mastersetting",
        },
        {
          id: "size",
          label: "Size",
          link: "/size",
          parentId: "Mastersetting",
        },
        {
          id: "specifications",
          label: "Specifications",
          link: "/specifications",
          parentId: "Mastersetting",
        },
        {
          id: "faq",
          label: "FAQ",
          link: "/faq",
          parentId: "Mastersetting",
        },

        {
          id: "Return & Exchange Policy",
          label: "Return & Exchange Policy",
          link: "/return&ExchangePolicy",
          parentId: "Mastersetting",
        },
        {
          id: "Terms & Condition",
          label: "Terms & Condition",
          link: "/terms&Condition",
          parentId: "Mastersetting",
        },
        {
          id: "News Letters",
          label: "News Letters",
          link: "/newsLetters",
          parentId: "Mastersetting",
        },
      ],
    },
    {
      id: "Bannersetting",
      label: "Banner Setting",
      icon: "bi bi-aspect-ratio-fill",
      link: "/#",

      click: function (e) {
        e.preventDefault();
        setIsBanner(!isBanner);
        setIscurrentState("isbanner");
        updateIconSidebar(e);
      },
      stateVariables: isBanner,
      subItems: [
        {
          id: "slider1",
          label: "Slide 1",
          link: "/banner/slider1",
          parentId: "Bannersetting",
        },
        {
          id: "slider2",
          label: "Slider 2",
          link: "/banner/slider2",
          parentId: "Bannersetting",
        },
        {
          id: "mobileSlider",
          label: "Mobile Slider",
          link: "/banner/mobileSlider",
          parentId: "Bannersetting",
        },
        {
          id: "banner section",
          label: "Banner Section",
          link: "/banner/bannerSection",
          parentId: "Bannersetting",
        },
        // {
        //     id: "OfferSection",
        //     label: "Offer Section",
        //     link: "/offerSection",
        //     parentId: "Bannersetting",
        // },
      ],
    },

    {
      id: "orders",
      label: "Orders",
      icon: "bi bi-cart4",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsOrder(!isOrder);
        setIscurrentState("Orders");
        updateIconSidebar(e);
      },
      stateVariables: isOrder,
      subItems: [
        {
          id: "listview",
          label: "List View",
          link: "/orders-list-view",
          parentId: "orders",
        },
        // {
        //     id: "overview",
        //     label: "Overview",
        //     link: "/orders-overview",
        //     parentId: "orders",
        // },
      ],
    },

    // {
    //     id: "calendar",
    //     label: "Calendar",
    //     icon: "bi bi-calendar-week",
    //     link: "/calendar",
    // },
    // {
    //     id: "seller",
    //     label: "Sellers",
    //     icon: "bi bi-binoculars",
    //     link: "/#",
    //     click: function (e) {
    //         e.preventDefault();
    //         setIsSellers(!isSellers);
    //         setIscurrentState('Sellers');
    //         updateIconSidebar(e);
    //     },
    //     stateVariables: isSellers,
    //     subItems: [
    //         {
    //             id: "listview",
    //             label: "List View",
    //             link: "/sellers-list-view",
    //             parentId: "seller",
    //         },
    //         {
    //             id: "gridview",
    //             label: "Grid View",
    //             link: "/seller-grid-view",
    //             parentId: "seller",
    //         },
    //         {
    //             id: "overview",
    //             label: "Overview",
    //             link: "/seller-overview",
    //             parentId: "seller",
    //         },
    //     ],
    // },
    // {
    //     id: "invoice",
    //     label: "Invoice",
    //     icon: "bi bi-archive",
    //     link: "/#",
    //     click: function (e) {
    //         e.preventDefault();
    //         setIsInvoice(!isInvoice);
    //         setIscurrentState('Invoice');
    //         updateIconSidebar(e);
    //     },
    //     stateVariables: isInvoice,
    //     subItems: [
    //         {
    //             id: "listview",
    //             label: "List View",
    //             link: "/invoices-list",
    //             parentId: "invoice",
    //         },
    //         {
    //             id: "overview",
    //             label: "Overview",
    //             link: "/invoices-details",
    //             parentId: "invoice",
    //         },
    //         {
    //             id: "createinvoice",
    //             label: "Create Invoice",
    //             link: "/invoices-create",
    //             parentId: "invoice",
    //         },
    //     ],
    // },
    {
      id: "userslist",
      label: "Users List",
      icon: "bi bi-person-bounding-box",
      link: "/users-list",
    },
    {
      id: "shipping",
      label: "Shipping",
      icon: "bi bi-truck",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsShipping(!isShipping);
        setIscurrentState("Shipping");
        updateIconSidebar(e);
      },
      stateVariables: isShipping,
      subItems: [
        {
          id: "shippinglist",
          label: "Shipping List",
          link: "/shipping-list",
          parentId: "shipping",
        },
        {
          id: "shipments",
          label: "Shipments",
          link: "/shipments",
          parentId: "shipping",
        },
      ],
    },
    {
      id: "coupons",
      label: "Coupons",
      icon: "bi bi-tag",
      link: "/coupons",
    },
    {
      id: "reviews-ratings",
      label: "Reviews & Ratings",
      icon: "bi bi-star",
      link: "/reviews-ratings",
    },
    // {
    //     id: "brands",
    //     label: "Brands",
    //     icon: "bi bi-shop",
    //     link: "/brands",
    // },
    // {
    //     id: "statistics",
    //     label: "Statistics",
    //     icon: "bi bi-pie-chart",
    //     link: "/statistics",
    // },
    // {
    //     id: "localization",
    //     label: "Localization",
    //     icon: "bi bi-coin",
    //     link: "/#",
    //     click: function (e) {
    //         e.preventDefault();
    //         setIsLocalization(!isLocalization);
    //         setIscurrentState('Localization');
    //         updateIconSidebar(e);
    //     },
    //     stateVariables: isLocalization,
    //     subItems: [
    //         {
    //             id: "transactions",
    //             label: "Transactions",
    //             link: "/transactions",
    //             parentId: "localization",
    //         },
    //         {
    //             id: "currency-rates",
    //             label: "Currency Rates",
    //             link: "/currency-rates",
    //             parentId: "localization",
    //         },
    //     ],
    // },
    {
      id: "accounts",
      label: "Accounts",
      icon: "bi bi-person-circle",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsAuth(!isAuth);
        setIscurrentState("Auth");
        updateIconSidebar(e);
      },
      stateVariables: isAuth,
      subItems: [
        // {
        //     id: "myAccount",
        //     label: "My Accounts",
        //     link: "/account",
        //     parentId: "account",
        // },
        {
          id: "myAccount",
          label: "My Account",
          link: "/settings",
          parentId: "account",
        },
        {
          id: "myAccount",
          label: "Admin List",
          link: "/admin-list",
          parentId: "account",
        },
        // {
        //     id: "signup",
        //     label: "Sign Up",
        //     link: "/auth-signup-basic",
        //     parentId: "account",
        // },
        // {
        //     id: "signin",
        //     label: "Sign In",
        //     link: "/auth-signin-basic",
        //     parentId: "account",
        // },
        // {
        //     id: "password-reset",
        //     label: "Password Reset",
        //     link: "/auth-pass-reset-basic",
        //     parentId: "account",
        // },
        // {
        //     id: "password-create",
        //     label: "Password Create",
        //     link: "/auth-pass-change-basic",
        //     parentId: "account",
        // },
        // {
        //     id: "success-message",
        //     label: "Success Message",
        //     link: "/auth-success-msg-basic",
        //     parentId: "account",
        // },
        // {
        //     id: "two-step-verify",
        //     label: "Two Step Verify",
        //     link: "/auth-twostep-basic",
        //     parentId: "account",
        // },
        // {
        //     id: "logout",
        //     label: "Logout",
        //     link: "/auth-logout-basic",
        //     parentId: "account",
        // },
        // {
        //     id: "auth-404",
        //     label: "Error 404",
        //     link: "/auth-404",
        //     parentId: "account",
        // },
        // {
        //     id: "auth-500",
        //     label: "Error 500",
        //     link: "/auth-500",
        //     parentId: "account",
        // },
        // {
        //     id: "coming-soon",
        //     label: "Coming Soon",
        //     link: "/coming-soon",
        //     parentId: "account",
        // },
      ],
    },
    // {
    //     id: "components",
    //     label: "Components",
    //     icon: "bi bi-layers",
    //     link: "//themes.themesbrand.com/toner/react/components/index",
    //     isBadgeColorCustom: true,
    //     badgeName: "v1.0",
    //     badgeColor: "secondary"

    // },
    // {
    //     id: "multilevel",
    //     label: "Multi Level",
    //     icon: "bi bi-share",
    //     link: "/#",
    //     click: function (e) {
    //         e.preventDefault();
    //         setIsMultiLevel(!isMultiLevel);
    //         setIscurrentState('MuliLevel');
    //         updateIconSidebar(e);
    //     },
    //     stateVariables: isMultiLevel,
    //     subItems: [
    //         { id: "level1.1", label: "Level 1.1", link: "/#", parentId: "multilevel" },
    //         {
    //             id: "level1.2",
    //             label: "Level 1.2",
    //             link: "/#",
    //             isChildItem: true,
    //             click: function (e) {
    //                 e.preventDefault();
    //                 setIsLevel1(!isLevel1);
    //             },
    //             stateVariables: isLevel1,
    //             childItems: [
    //                 { id: 1, label: "Level 2.1", link: "/#" },
    //                 {
    //                     id: "level2.2",
    //                     label: "Level 2.2",
    //                     link: "/#",
    //                     isChildItem: true,
    //                     click: function (e) {
    //                         e.preventDefault();
    //                         setIsLevel2(!isLevel2);
    //                     },
    //                     stateVariables: isLevel2,
    //                     childItems: [
    //                         { id: 1, label: "Level 3.1", link: "/#" },
    //                         { id: 2, label: "Level 3.2", link: "/#" },
    //                     ]
    //                 },
    //             ]
    //         },
    //     ],
    // },
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
